import { DataHeader, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutARCycleCodes extends Layout {
    dataheaderARCycleCode: DataHeader;
    panelARCycleCode: Panel;
    sourceARCycleCode: DataSource;
    textboxDays: Textbox;
    textboxDaysMethod: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
}
